import { TFunction } from 'i18next'

import { importProducts, SelectableProductAccount } from '@features/products/query-api'
import { ProductPayload } from '@features/products/types/productPayload'
import { VatRate } from '@features/vatRates/types/vatRate'
import { findVatRateById } from '@features/vatRates/utils/findVatRateById'

import { ImportProductsResult } from '../types'
import { parseProductsImportCsv } from './parseProductsImportCsv'

const resolvePayload = (
  payload: ProductPayload,
  vatRates: VatRate[],
  accounts: SelectableProductAccount[],
): ProductPayload => {
  const vatRate = findVatRateById(vatRates, payload.vatRateId)
  const account = payload.accountId
    ? accounts.find(({ accountNo }) => String(accountNo) === payload.accountId)
    : undefined

  return { ...payload, vatPct: vatRate?.rate ?? 0, accountId: account?.id }
}

export const importProductsFromCsv = async (
  file: File,
  t: TFunction,
  vatRates: VatRate[],
  accounts: SelectableProductAccount[],
): Promise<ImportProductsResult> => {
  const { invalidProductTypeRows, payloads, submitted } = await parseProductsImportCsv(file, t)
  const resolvedPayloads = payloads.map((payload) => resolvePayload(payload, vatRates, accounts))

  if (resolvedPayloads.length === 0) {
    return { created: 0, invalidProductTypeRows, submitted }
  }

  const { data } = await importProducts(resolvedPayloads)

  return { created: data.length, invalidProductTypeRows, submitted }
}
